define([
    'edge/platform/base/BaseCtrl',
    'edge/platform/modelvalidation/FormUtil'
], (BaseCtrl, FormUtil)=> {
    const fn = ($scope, $anchorScroll, submissionViewModel,StateUtils )=> {
        const ctrl = Object.create(BaseCtrl);
        const submissionVm = submissionViewModel();
        const flowModel = StateUtils.activeDataForState(true).flowModel;
        
        ctrl.init = ()=> {
            $anchorScroll();
            $scope.view = submissionVm.draftData.lobs.homeowners.construction;
            // Temp code :: Uncomment this once additonal info page gets displayed
            /***********************************************************************
            * TODO:: change this value once the additional info screen is migrated *
            ************************************************************************/
            // Get homeType from additionalInfo details
            var additionalInfo = submissionVm.draftData.lobs.homeowners.additionalInfo.value;
            var homeType = additionalInfo.homeType; // "X"

            // Ignore type codes other than "Brick (B)" and "Frame (F)" if occupancy is "owner"
            if (homeType == "HO3" || homeType == "HO6"){
                //$scope.constructionIgnoreList = ['C', 'L', 'S', 'OTHER'];
                // For Dev
                //$scope.constructionIgnoreList = ['C', 'L', 'S', 'OTHER','F','M','FireResistiveSteel','FramewithSiding','LessMasonryVeneer','MoreMasonryVeneer','Log'];
                $scope.constructionIgnoreList = ['C', 'L', 'S', 'OTHER','F','M','Superior','MasonryVeneer'];
            }
            
            // Temp code to show roof images only mentioned in story card
            // standingSeamMetal,ArchitecturalShingles,ConcreteTile, WoodShakeShingles
            // Changes as per the changes done in RoofType.tti in PC - 16/09/2016
            // Copying old images and renaming to current type codes and display keys in resources.json
            //$scope.roofIgnoreList = ["tileclay", "plastic", "targravel", "slate", "fiberCement", "fiberAluminum"];
            // For Dev
            $scope.roofIgnoreList = ["AsphaltFiberComp", "ClayTileSlate", "CorrugatedMetalTin", "FlatFoamComposite", "FlatMembrane", "FlatTarGravel", "FlatPitchedRoof"];
            if (!$scope.view.value) {
                var currentYear = new Date().getFullYear();
                $scope.view.value = {
                    hasGarage: false, // requirement
                    //secondaryHeatingExists: false,
                    foundationType : "slab",
                    plumbingType : "pvc",
                    plumbingUpgradeExists : false,
                    plumbingUpgradeYear : currentYear,
                    //primaryHeatingType : "Gas",
                    //heatingUpgradeExists : false,
                    //heatingUpgradeYear : 2016,
                    wiringType : "copper",
                    electricalType : "CircuitBreaker",
                    wiringUpgradeExists : false,
                    wiringUpgradeYear : currentYear// requirement
                };

                // Check if home type is rent
                // if it is rent then fill default values for construction screen 
                // and go to next state
                if (homeType == "HO4") {

                    // Assign default values
                    $scope.view.value.yearBuilt = 2004;
                    $scope.view.value.storiesNumber = "1";
                    $scope.view.value.constructionType = "Frame";
                    $scope.view.value.roofType = "standingSeamMetal";
                    $scope.view.value.roofUpgradeExists = false;
                    $scope.view.value.isFlatRoof = false;
                    $scope.view.value.primaryHeatingType = "CentralElectric";
                    $scope.view.value.secondaryHeatingExists = false;
                    
                }
            }            

            // Add default value
            /*if ($scope.view.value.roofUpgradeExists == undefined){
                $scope.view.value.roofUpgradeExists = false;
            }*/  
            
            if (homeType == "HO4") {
                // var savePromise = $scope.conditionallySaveSubmission();
                //$scope.goToNext(savePromise, $filter('translate')('quoteandbind.ho.controllers.HOConstructionCtrl.Saving submission'));
                flowModel.next(submissionVm, true);
            }
        };
        
        // Roof upgrade exists
        ctrl.roofUpgradeExists = (val)=> {
            
            //console.log("roofUpgradeExists: ",typeof val, val);
            
            if(val == true){
                
                return true;
            }
            else if(val == false){
                return false;
            }
            
            return undefined;
        };

        ctrl.isOther = (val)=> {
            return val && val.toLowerCase() === 'other';
        };

        ctrl.next = (nextFn, form)=> {
            FormUtil.markFormsSubmitted(form);
            //console.log("construction: ",$scope.view.storiesNumber, $scope.view.value.storiesNumber);

            /*if($scope.view.value.storiesNumber == "Unknown"){
                $scope.view.value.storiesNumber = 1;
             }*/

            // Temp code
            //delete $scope.view.value["roofFlat"];

            // Default value for roof flat
            $scope.view.value.hasGarage = false;
            // Delete roofUpgradeYear if roofUpgradeExists is false
            if ($scope.view.value.roofUpgradeExists == false){
                delete $scope.view.value["roofUpgradeYear"];
            }
            
            var questions = submissionVm.draftData.lobs.homeowners.preQualQuestionSets.value[0]["answers"];
            
            //assigning the construction value for pre question set which is mandatory and asked by Iris to be assigned from constuction page
            questions["yearOfCons_aaa"] = $scope.view.value.yearBuilt;            
            nextFn(submissionVm);
        };

        return ctrl.create($scope);
    };
    fn.$inject = ['$scope', '$anchorScroll', 'submissionViewModel','StateUtils'];

    return fn;
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/ho/controllers/HOConstructionCtrl.js
 **/